export default __webpack_public_path__ + "static/media/money.4dc36151.png";